// 特设费用
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle" @editViewDataUpdate="editViewDataUpdate"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style="height: calc(100vh - -35px);">
          <vxe-grid :stripe="true" border="default" :row-config="{ isHover: true }" show-overflow height="100%" ref="table-m1" v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

            <template #form>
              <div class="clearfix screen-btns">
                <div class="fl">
                  <vxe-button status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog">新增
                  </vxe-button>
                </div>
                <div class="fr">
<!--                  <vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"-->
<!--                              status="primary" plain>重置-->
<!--                  </vxe-button>-->
                  <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData"
                        @submit="searchEvent" @reset="searchEvent">
                <vxe-form-item title="特设费用名称:" field="code">
                  <template v-slot>
                    <el-input v-model="formData.name" size="small" clearable/>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="类型:" field="name">
                  <template v-slot>
<!--                    <el-input v-model="formData.feeType" size="small" clearable/>-->
                    <el-select v-model="formData.feeType">
                      <el-option label="向公司申请" :value="1"/>
                      <el-option label="向用户收取" :value="2"/>
                    </el-select>
                  </template>
                </vxe-form-item>
              </vxe-form>
            </template>
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import editView from './edit.vue'
import {initVxeTable} from '@/const/crud/admin/table'
import pager from '@/components/pager/index.vue'

export default {
  components: {editView, pager},
  data() {
    return {
      total: 0,
      getListPageUrl: '/basic/sfSpecialFeeSubject/getListPage',
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      formData: {
        name: '',
        feeType: '',
      },
      pageSizes: [10, 20, 100],
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        name: '',
        feeType: '',
      },
      editViewDataUpdateFlag: false,
      columns: [
        {type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left'},
        { title: '特设费用名称', field: 'name', width: 150, },
        { title: '类型', field: 'feeType', width: 150, slots: {
            default: ({row}) => {
              if (row.feeType == 1) {
                return [
                  <div>
                    <span>向公司申请</span>
                  </div>
                ];
              } else if (row.feeType == 2) {
                return [
                  <div>
                    <span>向用户收取</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '金额', field: 'price', width: 150, },
        { title: '计价单位', field: 'unit', width: 150, },
        { title: '启用', field: 'stat', width: 150, slots: {
            default: ({ row }) => {
              if (row.stat == 0) {
                return [
                  <div class="txt-status disable">
                    <span>禁用</span>
                  </div>
                ];
              } else if (row.stat == 1) {
                return [
                  <div class="txt-status">
                    <span>启用</span>
                  </div>
                ];
              }
            }
          }
        },
        { field: 'createTime', title: '创建时间', width: 150 },
        { title: '创建人', field: 'createBy', width: 150, },
        { width: 47, fixed: 'right', title: '', sortable: false, slots: {
            default: ({row}) => {
              return [
                <div>
                  <a
                    href="javascript:void(0);"
                    class="a-link"
                    onclick={() => {
                      this.openEditDialog(row.id);
                    }}
                  >
                    <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                popper-class="tooltip-skin">
                      <i class="el-icon-edit"/>
                    </el-tooltip>
                  </a>
                </div>
              ];
            }
          }
        }
      ]
    };
  },
  watch: {
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    },
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
  },
  methods: {
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: this.getListPageUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      this.requestParam.name = this.formData.name
      this.requestParam.feeType = this.formData.feeType
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 重置
    resetEvent() {
      this.formData = {
        feeType: '',
        name: ''
      }

      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.requestParam.name = ''
      this.requestParam.feeType = ''

      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true
    }
  }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}
</style>
